import React from "react";
import {
    traducirPagina,
    descargarDocPasandoBase64Generico

} from "../../librerias/funciones"
import { Drawer } from 'antd';

import { CloseOutlined, GlobalOutlined, FileExcelOutlined } from "@ant-design/icons";
import { MDBBtn } from 'mdbreact';
import { GetEstadisticasEvolucionMarcaDetalleEnAPI, GetCSVEnAPI } from "../../action/actionCreatorsRequests";

export const FichaDetalleMarca = (props) => {
    const [initComponent, setInitComponent] = React.useState({
        REGISTROS: []
    })

    const GetEstadisticasEvolucionMarcaDetalle = async (ID_SOCIO, ID_DEPARTAMENTO, ANYO, MARCA) => {
        ID_DEPARTAMENTO = ID_DEPARTAMENTO === undefined || ID_DEPARTAMENTO === null ? 0 : ID_DEPARTAMENTO
        let registros = await GetEstadisticasEvolucionMarcaDetalleEnAPI(ID_SOCIO, ID_DEPARTAMENTO, ANYO, MARCA)
        const { OK, REGISTROS } = registros === undefined ? { OK: false, REGISTROS: null } : registros

        if (OK) {
            initComponent.REGISTROS = REGISTROS
            setInitComponent({ ...initComponent })
        }
    }



    const changeKeyObjects = (arr, replaceKeys) => {
        return arr.map(item => {

            const newItem = {};

            Object.keys(item).forEach(key => {
                let replace = replaceKeys[key] === undefined ? key : replaceKeys[key]
                newItem[replace] = item[[key]];
            });

            return newItem;

        });
    };


    const generarCSV = async (REGISTROS) => {
        const replaceKeys = {
            ID_TAREA: traducirPagina("ID").toUpperCase(),
            FECHA: traducirPagina("Fecha").toUpperCase(),
            NOMBRE_CLIENTE: traducirPagina("Cliente").toUpperCase(),
            MATRICULA_MARCA: traducirPagina("Marca").toUpperCase(),
            MATRICULA_MODELO: traducirPagina("Modelo").toUpperCase(),
            MATRICULA_MOTOR: traducirPagina("Motor").toUpperCase(),
            MATRICULA_CODIGO_MOTOR: traducirPagina("Codigo_motor").toUpperCase(),
            MATRICULA: traducirPagina("Matricula").toUpperCase(),
            TECNICO_CIERRE: traducirPagina("Tecnico_cierre").toUpperCase(),
            TIPO_ABONO_DEVOLUCION: traducirPagina("Tipo").toUpperCase(),
            DESCRIPCION: traducirPagina("Descripcion").toUpperCase(),
            TIPO_TAREA: traducirPagina("Tipo_de_tarea").toUpperCase(),
            NIVEL_TAREA: traducirPagina("Nivel_tarea").toUpperCase(),

        };




        const REGISTROS_TRADUCIDOS = changeKeyObjects(REGISTROS, replaceKeys);

        GetCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })

    }


    React.useEffect(() => {
        const { ID_SOCIO, ID_DEPARTAMENTO, MARCA, ANYO } = props.REGISTROS

        GetEstadisticasEvolucionMarcaDetalle(ID_SOCIO, ID_DEPARTAMENTO, ANYO, MARCA)
    }, [])


    return <div>
        <Drawer
            width={"90%"}
            onClose={() => {
                if (props.TIPO_FICHA === "MASTER") {
                    props.CERRAR.setState({ ABRIR_FICHA_RMI_FLUIDOS: false })
                } else {
                    props.CERRAR_FICHA(false)
                }
            }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            closable={false}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>


            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {

                        if (props.TIPO_FICHA === "MASTER") {
                            props.CERRAR.setState({ ABRIR_FICHA_RMI_FLUIDOS: false })
                        } else {
                            props.CERRAR_FICHA(false)
                        }

                    }}></CloseOutlined>
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>


                    <div>
                        <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => {
                            /*EstadisticasSertecMensualesPorUsuarioCSV() */
                            generarCSV(initComponent.REGISTROS)
                        }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>

                    </div>
                </div>
            </div>




            <div className="margen_tabla" style={{marginTop:'20px'}}>
                {initComponent.REGISTROS === null ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                    :
                    initComponent.REGISTROS.length > 0 ?
                    <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(90)}px )` }}>

                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ minWidth: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("ID").toUpperCase()}</th>
                                        <th style={{ minWidth: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Fecha").toUpperCase()} </th>
                                        <th style={{ minWidth: '300px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Cliente").toUpperCase()}</th>
                                        <th style={{ minWidth: '165px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Modelo").toUpperCase()}</th>
                                        <th style={{ minWidth: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Motor").toUpperCase()}</th>
                                        <th style={{ minWidth: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Codigo_motor").toUpperCase()}</th>
                                        <th style={{ minWidth: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Codigo_averia").toUpperCase()}</th>

                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Matricula").toUpperCase()}</th>
                                        <th style={{ minWidth: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tecnico_cierre").toUpperCase()}</th>
                                        <th style={{ minWidth: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Tipo").toUpperCase()}</th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Descripcion").toUpperCase()}</th>
                                        <th style={{ minWidth: '220px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tipo_de_tarea").toUpperCase()}</th>
                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Nivel_tarea").toUpperCase()}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {initComponent.REGISTROS.map((registro, i) =>
                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.ID_TAREA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.FECHA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.NOMBRE_CLIENTE}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_MODELO}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_MOTOR}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_CODIGO_MOTOR}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.CODIGO_AVERIA}</td>



                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TECNICO_CIERRE}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TIPO_ABONO_DEVOLUCION}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DESCRIPCION}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TIPO_TAREA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.NIVEL_TAREA}</td>



                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>


        </Drawer>
    </div>;
};